module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/cover"
    }
  }, [_vm._v("THE CASE OF THE SLIDING POOL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter01"
    }
  }, [_vm._v("1: The Sliding Pool")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter02"
    }
  }, [_vm._v("2: John Doe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter03"
    }
  }, [_vm._v("3: Murder Most Foul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter04"
    }
  }, [_vm._v("4: Naga Orashi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter05"
    }
  }, [_vm._v("5: Fred Lundman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: Rosita")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: Dr. Leo Hartman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: The Midtown Manhattan National Bank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: Blind Alleys")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: The Police Artist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: Ishido")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12: The Bomb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13: Eric Saunders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14: The Game Players")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15: Samurai")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CASE OF THE KIDNAPPED ANGEL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1: The Kidnapped Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2: Mike Barton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: Malibu Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: San Yisidro")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: The House on the Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: The Returned Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: The Departed Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Mrs. Holtz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: The Zendo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: The Loser")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: The Autopsy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12: The Suitcase")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13: Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CASE OF THE MURDERED MACKENZIE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter01#sect-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/biography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Howard Fast")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b0222d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 72
// module chunks = 0